import { ButtonProps } from "../../interfaces/Button.interface";

/**
 * Determines whether a CTA button should be rendered.
 * A CTA is considered valid only if it has both a visible label and a link.
 */
export const isValidCTA = (ctaItem: ButtonProps | undefined): boolean => {
  return !!ctaItem?.label && !!ctaItem?.link;
};

export default isValidCTA;
